import * as amplitude from '@amplitude/analytics-browser';
import { AMPLITUDE_FEATURE_FLAG } from './features';

function getAmplitudeApiKey() {
    const reactAppEnv = process.env.REACT_APP_KB_ENV;
    const isBuddyEnv = process.env.REACT_APP_IS_BUDDY_ENV;
    if (reactAppEnv === 'dev' || isBuddyEnv === 'true') {
        return '';
    }
    return 'cc9fc57be55a0e6bbfcbd7271361f9bd';
}

const apiKey = getAmplitudeApiKey();

function formatAmplitudeUserId(id) {
    if (id == null || id === '') return '';
    return `hiver_${id}`;
}

class Amplitude {
    constructor() {
        this._initialized = false;
        this._ugId = null;
        this._isFeatureEnabled = false;
    }

    init(userDetails = {}) {
        if (this._initialized || !apiKey) return;

        this._isFeatureEnabled = userDetails.availableFeatures?.[AMPLITUDE_FEATURE_FLAG] === true;
        if (!this._isFeatureEnabled) return;

        amplitude.init(apiKey, { defaultTracking: true });
        this._initialized = true;

        if (userDetails.usergroupId != null) {
            this._ugId = userDetails.usergroupId;
        }

        const amplitudeUserId = formatAmplitudeUserId(userDetails.userId);
        if (amplitudeUserId) {
            amplitude.setUserId(amplitudeUserId);
        }

        const identifyObj = new amplitude.Identify();
        identifyObj.set('usergroup_id', userDetails.usergroupId ?? '');
        amplitude.identify(identifyObj);
    }

    track(eventName, properties = {}) {
        if (!this._initialized || !this._isFeatureEnabled) return;
        amplitude.track(eventName, {
            ug_id: this._ugId,
            ...properties,
        });
    }
}

export const amplitudeTracker = new Amplitude();
